@if (object1) {
  <con-object-inspector [object]="object1">
  </con-object-inspector>
}
<small>Other version:</small>
@if (object2) {
  <con-object-inspector [object]="object2">
  </con-object-inspector>
}
